<div class="loader-container">
    <img src="assets/gifs/logo-animation.gif" />
</div>